import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "career-app" }
const _hoisted_2 = ["aria-sort"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: "3" }

import {useApi} from '@util/api-service';
import {onBeforeMount, ref} from "vue";
import {IJobs} from "@features/Components/CareerBlock/Scripts/App/interfaces/IJobs";
import {ICareerResponse} from "@features/Components/CareerBlock/Scripts/App/interfaces/ICareerBlockResponse";
import {ITranslations} from "@features/Components/CareerBlock/Scripts/App/interfaces/ITranslations";


export default /*@__PURE__*/_defineComponent({
  __name: 'CareerApp',
  setup(__props) {

const {get} = useApi(`/career`);
const jobs = ref<IJobs[]>([])
const translations = ref<ITranslations>();
const sortAsc = ref(true);

onBeforeMount(() => {
  get<ICareerResponse>().then((response: ICareerResponse) => {
    jobs.value = response.jobs;
    translations.value = response.translations;
  });
});

function sortByDeadline() {
  jobs.value.sort((a, b) => {
    const dateA = new Date(a.deadline).getTime();
    const dateB = new Date(b.deadline).getTime();
    return sortAsc.value ? dateA - dateB : dateB - dateA;
  });
  sortAsc.value = !sortAsc.value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, _toDisplayString(translations.value?.title), 1 /* TEXT */),
          _createElementVNode("th", null, _toDisplayString(translations.value?.location), 1 /* TEXT */),
          _createElementVNode("th", {
            "aria-sort": sortAsc.value ? 'ascending' : 'descending'
          }, [
            _createElementVNode("button", { onClick: sortByDeadline }, [
              _createTextVNode(_toDisplayString(translations.value?.deadline) + " ", 1 /* TEXT */),
              (sortAsc.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "↑"))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "↓"))
            ])
          ], 8 /* PROPS */, _hoisted_2)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (jobs.value.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(jobs.value, (job) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: job.title
              }, [
                _createElementVNode("td", null, [
                  (!!job.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: job.link,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(job.title), 9 /* TEXT, PROPS */, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(job.title), 1 /* TEXT */))
                ]),
                _createElementVNode("td", null, _toDisplayString(job.location), 1 /* TEXT */),
                _createElementVNode("td", null, _toDisplayString(job.deadline), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          : (_openBlock(), _createElementBlock("tr", _hoisted_7, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(translations.value?.noJobsMessage), 1 /* TEXT */)
            ]))
      ])
    ])
  ]))
}
}

})